/**
 * Conditions générales d'utilisation de Colis2Ship — PROJET rédigé le 2026-10-28 (frais Colis2Ship, C8, partie 3c),
 * à faire relire par un juriste avant la production. La version doit rester celle de `backend/legal.py`
 * (TERMS_VERSION), vérifié par `backend/tests/unit/test_legal.py` ; l'inscription enregistre la version acceptée.
 * Les montants et délais reprennent les règles du code (commission.py, propositions, séquestre) : les changer ici
 * quand ils changent là-bas.
 */
export const TERMS_VERSION = '2026-10-28';

export const TERMS_SECTIONS = [
  {
    title: '1. Objet et rôle de Colis2Ship',
    paragraphs: [
      'Colis2Ship est une plateforme de mise en relation entre des expéditeurs, qui veulent faire transporter un colis, et des transporteurs, particuliers ou professionnels, qui effectuent un trajet entre l’Europe, l’Afrique et l’Amérique.',
      'Colis2Ship n’est pas transporteur : le transport est effectué par le transporteur, sous sa responsabilité. Colis2Ship fournit la plateforme, sécurise le paiement et accompagne la remise du colis et la résolution des litiges.',
    ],
  },
  {
    title: '2. Compte et vérifications',
    paragraphs: [
      'La consultation des annonces est libre. Publier, proposer, réserver, écrire à un membre ou recevoir des versements exige des vérifications : adresse e-mail, numéro de téléphone et pièce d’identité selon l’action. Ce qui manque est indiqué à chaque étape.',
      'Chaque membre s’engage à fournir des informations exactes et à garder ses identifiants confidentiels. Un compte peut être suspendu en cas de fraude, d’usurpation ou de manquement grave aux présentes conditions.',
    ],
  },
  {
    title: '3. Annonces et propositions',
    paragraphs: [
      'Un expéditeur publie un colis, un transporteur publie un trajet ; chaque annonce est validée par Colis2Ship avant d’être visible.',
      'Trois façons de conclure : la réservation avec paiement sécurisé (la carte est autorisée tout de suite, débitée seulement si le transporteur accepte, au plus tard 7 jours après) ; la proposition directe au prix de l’annonce (réponse attendue sous 12 heures) ; la négociation du prix (réponse attendue sous 3 jours). Sans réponse dans ces délais, la proposition prend fin.',
    ],
  },
  {
    title: '4. Prix, commission et frais Colis2Ship',
    paragraphs: [
      'Le prix du transport est fixé entre l’expéditeur et le transporteur. Il est affiché dans la devise de la mission, avant tout paiement.',
      'Commission du transporteur : retenue sur le prix qu’il perçoit — 10 % (au moins 2 €), 8 % (au moins 1,50 €) sur sa première mission ou une réservation avec paiement sécurisé, 7 % (au moins 1 €) avec l’abonnement PRO. Le minimum est converti dans la devise de la mission au taux du jour. Le prix d’une mission doit valoir au moins deux fois cette commission minimale.',
      'Frais Colis2Ship de l’expéditeur : ajoutés au prix du transport — 0,99 € jusqu’à 30 €, 1,99 € jusqu’à 100 €, 2 % au-delà dans la limite de 9 €, convertis dans la devise de la mission. La commission et les frais ne dépassent jamais ensemble 15 % du prix : ce sont les frais qui sont réduits. Des frais inférieurs à 0,50 € ne sont pas facturés. La première mission de chaque expéditeur est sans frais.',
      'Pendant la période de lancement, les frais Colis2Ship sont offerts à tous les expéditeurs ; leur montant est affiché barré. Colis2Ship préviendra ses membres avant de les appliquer.',
    ],
  },
  {
    title: '5. Paiement et versement au transporteur',
    paragraphs: [
      'Les paiements sont traités par Stripe. Le prix du transport est encaissé par Colis2Ship pour le compte du transporteur et conservé jusqu’à la livraison ; les frais Colis2Ship rémunèrent la plateforme.',
      'Après une proposition acceptée, l’expéditeur dispose de 48 heures pour payer ; passé ce délai, la mission est annulée.',
      'Le transporteur reçoit son net (prix moins commission), en euros, 48 heures après la confirmation de la livraison par l’expéditeur, sur un compte de versement ouvert chez Stripe. Les frais de conversion de devise de Stripe sont supportés par Colis2Ship.',
      'Un reçu de paiement est envoyé à l’expéditeur par e-mail et reste disponible dans la mission.',
    ],
  },
  {
    title: '6. Annulation et remboursement',
    paragraphs: [
      'Une réservation refusée, expirée ou annulée avant l’acceptation n’est jamais débitée : l’autorisation de la carte est libérée.',
      'Lorsqu’un remboursement est décidé (annulation après paiement, litige tranché en faveur de l’expéditeur), le paiement est rendu en entier, frais Colis2Ship compris.',
    ],
  },
  {
    title: '7. Remise, livraison et litiges',
    paragraphs: [
      'La remise et la livraison sont confirmées par des codes QR : l’expéditeur présente le sien au transporteur au départ, le destinataire le sien à l’arrivée.',
      'L’expéditeur dispose de 48 heures après la fin de la mission pour ouvrir un litige. Colis2Ship examine les éléments des deux parties et décide de verser le paiement au transporteur ou de le rembourser à l’expéditeur.',
    ],
  },
  {
    title: '8. Objets interdits et responsabilités',
    paragraphs: [
      'Il est interdit de confier ou de transporter des objets illicites, dangereux, contrefaits ou dont le transport est réglementé sans autorisation, ainsi que des espèces. L’expéditeur décrit honnêtement le contenu de son colis ; le transporteur peut refuser un colis dont le contenu ne correspond pas à l’annonce.',
      'Chaque membre respecte les règles douanières des pays traversés. Colis2Ship n’est pas partie au contrat de transport et ne répond pas de son exécution, sous réserve de ses propres obligations de plateforme.',
    ],
  },
  {
    title: '9. Obligations fiscales et sociales',
    paragraphs: [
      'Les revenus perçus par l’intermédiaire de Colis2Ship peuvent être imposables et soumis à cotisations sociales. Chaque transporteur est responsable de leur déclaration. Lorsque la loi le prévoit, Colis2Ship transmet à l’administration fiscale les informations relatives aux revenus perçus par ses utilisateurs et adresse à chacun le récapitulatif qui le concerne.',
    ],
  },
  {
    title: '10. Données personnelles',
    paragraphs: [
      'Colis2Ship traite les données nécessaires au fonctionnement du service. Les autres membres ne voient que le prénom, l’initiale du nom et les vérifications obtenues, puis le nom complet une fois une mission conclue entre eux. Les pièces d’identité sont supprimées 30 jours après la décision de vérification. La politique de confidentialité détaille ces traitements et vos droits.',
    ],
  },
  {
    title: '11. Modification des conditions, droit applicable',
    paragraphs: [
      'Colis2Ship peut modifier les présentes conditions ; la nouvelle version est datée et doit être acceptée pour continuer à utiliser le service.',
      'Les présentes conditions sont soumises au droit français. En cas de différend, une solution amiable est recherchée d’abord ; un consommateur peut recourir gratuitement au médiateur de la consommation dont Colis2Ship relève.',
    ],
  },
];
